<template>
	<div>
		<div class="main">
			<div v-if="isVideo" class="video">
				<!-- <div class="layer"></div> -->
				<video-player :playsinline="true" class="vjs-custom-skin videoPlayer" :options="playerOptions"></video-player>
			</div>
			<div class="user">
				<p style="text-align: center;">報名人員（{{ isLive }}/{{ userList.length }}）</p>
				<div class="user-list">
					<p v-for="(item, index) in userList" :key="index" :class="item.isLive ? 'blue' : ''">
						<span class="userName">{{ item.name }}</span>
						<span class="isLiveTime">{{ item.isLiveTime }}</span>
					</p>
				</div>
			</div>
		</div>
		<el-button @click="$router.back()">結束觀看</el-button>
	</div>
</template>

<script>
import 'video.js/dist/video-js.css';
import 'videojs-flash';
import { videoPlayer } from 'vue-video-player'; // 有多个输出值，引入花括号
export default {
	data() {
		return {
			playerOptions: {
				fluid: true,
				sources: [
					{
						type: 'rtmp/mp4',
						src: ''
					}
				],
				techOrder: ['flash'],
				autoplay: true,
				muted: false, // 默认情况下将会消除任何音频。
				controls: false,
				notSupportedMessage:'獲取失敗，請確認正在直播'
			},
			liveId: '',
			msg: {},
			isVideo: false,
			userList: [],
			isLive: 0,
			timeoutId: ''
		};
	},
	components: {
		videoPlayer
	},
	created() {
		this.liveId = sessionStorage.getItem('liveId');
		this.axios.get('/manage/getManEnterClassroom?id=' + this.liveId).then(res => {
			if (res) {
				this.msg = res.result;
				this.playerOptions.sources[0].src = this.msg.liveFile;
				this.isVideo = true;
				this.$nextTick(() => {
					$('#pageHead').text(this.msg.sectionName);
				});
				console.log("直播？？",this.playerOptions)

			}
		});
		this.getUserNum();
	},
	methods: {
		getUserNum() {
			this.axios.get('/manage/getManHistoricalAudienceList/noLoad?id=' + this.liveId).then(res => {
				if (res) {
					let list = res.result,
						isLive = 0;
					list.forEach(item => {
						if (item.isLive) {
							isLive++;
						}
					});
					this.isLive = isLive;
					this.userList = list;
					this.timeoutId = setTimeout(() => {
						this.getUserNum();
					}, 6000);
				}
			});
		}
	},
	beforeDestroy() {
		clearTimeout(this.timeoutId);
	}
};
</script>
<style scoped>
.main {
	display: flex;
	justify-content: space-between;
}
.video {
	width: 60vw;
	position: relative;
/* 	margin-top: -5vh;
	z-index: -1; */
}
.layer {
	height: 5vh;
	width: 100%;
	background-color: white;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1;
}
.user {
	width: 20vw;
	height: 70vh;
	background-color: #e0e2e4;
}
.user-list {
	height: 92%;
	overflow-y: auto;
}
.user-list .blue {
	color: #00b0e8;
}
.user-list p {
	margin: 10px;
	display: flex;
	justify-content: space-between;
	color: #656565;
	border-bottom: 1px solid #ccc;
	padding-bottom: 2px;
}
.el-button {
	position: absolute;
	top: 90px;
	right: 45px;
}
.userName{
	max-width: 50%;
	font-size: 13px;
}
.isLiveTime{
	font-size: 12px;
}
</style>
